$(document).ready(function () {
    window.onbeforeunload = function () {
        axa.pleaseWait.show();
    }
});

/** APP TEMPLATE PACKAGE *************************************************/
var app = app || (function() {
    return {};
})();

/*** NEWS MANAGEMENT - SUB APP PACKAGE ************************/
app.news = app.news || (function () {

    /* ----- Private variables and methods ---- */

    return {

        /* ---- Public variables and methods ------ */

        /* Method to refresh the "More" links on the news */
        refreshMoreLinks : function() {
            $("#app-news .carousel-item > div > div").each(function () {
                var isActive = $(this).closest(".carousel-item").is(".active");
                if(!isActive) {
                    $(this).closest(".carousel-item").addClass("active");
                }
                var visibleHeight = $(this).closest(".carousel-item").height();
                var realHeight = $(this).height();
                if(!isActive) {
                    $(this).closest(".carousel-item").removeClass("active");
                }

                /* If more than 5px height are hidden => we show the "More" link*/
                if (realHeight - visibleHeight <= 5) { 
                    $(this).find(".moreLink").hide();
                }
                else {
                    $(this).find(".moreLink").show();
                }
            });
        }
    };
})();